<template>
  <div>
    <a-row type="flex" justify="space-between" align="top">

      <a-col :span="12">
        <a-row type="flex">
          <a-col :span="24" class="titulo">Buscar en lista negra</a-col>

        </a-row>
        <a-row type="flex" justify="space-between" style="margin-bottom: 30px">
          <a-col :span="20">

            <a-input-search
                class="shadowInputs w-100"
                placeholder="Escriba para buscar"
                v-model="buscar"
            />
          </a-col>
          <a-col :span="4">
            <a-spin :spinning="debounceSearchTimer !== null"></a-spin>
          </a-col>

        </a-row>
      </a-col>
      <a-col :span="12" />
      <a-col :span="16" style="word-break: break-all; background-color: white; padding: 10px; border-radius: 5px;" class="shadow">
        <a-table :columns="columnsListTable" :dataSource="blackList" :pagination="pagination" rowKey="id" >
        <span class="nowrap" slot="action" slot-scope="text, record">
          <a-button class="margin" type="primary" title="Eliminar" shape="circle" icon="delete" @click="showDeleteConfirm(record.id)" ></a-button>
        </span>
        </a-table>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-spin :spinning="loading">
      <a-row type="flex" justify="space-between">
        <a-col :span="10">
          <a-form
              layout="vertical"
              :form="formBlackList"
          >
            <h1 class="titulo" style="font-weight: bold; font-size: 16px; margin-bottom: 20px">Importar lista negra:</h1>

            <a-form-item>
          <span slot="label">
            Cargar Lista&nbsp;negra
            <a-tooltip title="Carge un archivo CSV con los contactos de la lista">
              <a-icon type="question-circle-o" />
            </a-tooltip>
          </span>
              <div class="container">
                <div class="large-12 medium-12 small-12 cell">
                  <label>Archivo formato .csv
                    <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                  </label>
                </div>
              </div>
            </a-form-item>

            <a-form-item>
              <a-row type="flex" justify="end" align="middle" :gutter="20">
                <a-col><a-button @click="submitLista" :disabled="file == ''" :loading="uploading" type="primary" html-type="submit" size="large" >Cargar</a-button></a-col>
              </a-row>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :span="2">
          <a-divider style="height: 100%" type="vertical"></a-divider>
        </a-col>
        <a-col :span="10" type="flex">
          <h1 class="titulo" style="font-weight: bold; font-size: 16px; margin-bottom: 20px">Agregar email a lista negra:</h1>
          <a-form :form="formAddContacto">
            <a-form-item>
                <span slot="label">
                  Email
                </span>
              <a-input
                  v-decorator="['email', {rules: [{ required: true, type:'email', message: 'Ingrese un email' }]}]"
                  class="shadowInputs"
              />
            </a-form-item>
            <a-form-item>
                <span slot="label">
                  Categoría&nbsp;
                </span>
              <a-select size="large" class="shadowInputs"  v-decorator="['categoryId', {rules: [{ required: true, message: 'Ingrese una categoría' }]}]">
                <a-select-option v-for="itemCategoria in CATEGORIAS" :key="'categoria_' + itemCategoria.id"
                                 :value='itemCategoria.id'>
                  {{ itemCategoria.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-col><a-button @click="submitContacto" :loading="submittingContacto" type="primary" html-type="submit" size="large" >Agregar</a-button></a-col>
          </a-form>
        </a-col>
      </a-row>
    </a-spin>

  </div>

</template>

<script>
import utils from '../service/service.js'
import categories from "@/service/categories";
export default {
  name: 'Blacklist',
  props: {

  },
  mixins:[utils, categories],
  data() {
    let columnsListTable = [
      { title: 'Email', dataIndex: 'email' },
      { title: 'Fecha', dataIndex: 'fecha'},
      { title: 'Categoría', dataIndex: 'category'},
      { title: 'Reason', dataIndex: 'reason'},
      { title: 'Acciones', scopedSlots: { customRender: 'action' }, width: '95px' },
    ];
    return {
       buscar:'',
       display_data:[],
       current: 1,
       loading: false,
       search: '',
       cantidadPorPagina:3,
       uploadData: {},
       pagination: {pageSize: 8},
       file: '',
       uploading: false,
       formBlackList: null,
       formAddContacto: null,
       submittingContacto: false,
       blackList:[],
       columnsListTable,

      debounceSearchTimer: null,

    }
  },
  computed: {
  },
  mounted: function() {
    this.formBlackList = this.$form.createForm(this);
    this.formAddContacto = this.$form.createForm(this);
    this.recent();
  },
  watch: {
    buscar: function() {
      this.searchEmail(true);
    }
  },
  methods:{
    showDeleteConfirm(id) {
      var $this = this;
      this.$confirm({
        title: '¿Estas seguro que queres eliminar este email de la lista negra?',
        content: 'Esto no se puede deshacer',
        okText: 'Si',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          $this.sendRequest({
            method: 'POST',
            url: `blacklist/delete/${id}`,
            data: {},
          }).then(({ code, message }) => {
            if (code === 200) {
              $this.$message.success("Email eliminado")
              $this.searchEmail(false);
            } else {
              $this.$swal({
                icon: "warning",
                title: "¡Lo sentimos!",
                text: message,
              });
            }
          })


        },
        onCancel() {
        },
      });
    },

    submitContacto(e){
      this.formAddContacto.validateFields(
          async (err) => {
            if (!err) {
              var fields = this.formAddContacto.getFieldsValue();
              let formData = new FormData();
              formData.append('email', fields["email"]);
              formData.append('categoryId', fields['categoryId']);

              this.loading = true;

              const { code, message } = await this.sendRequest({
                method: 'POST',
                url: `blacklist/addEmail`,
                data: formData,
                sendFile: true
              })
              this.loading = false;
              if (code === 200) {
                this.$message.success("Lista creada");
                this.formAddContacto.resetFields();
              } else {
                this.$swal({
                  icon: "warning",
                  title: "¡Lo sentimos!",
                  text: message,
                });
              }
            }
          },
      );
    },

    submitLista(e){
     this.formBlackList.validateFields(
        async (err) => {
          if (!err) {
            let formData = new FormData();
            formData.append('file', this.file);

            this.loading = true;

            const { code, message } = await this.sendRequest({
              method: 'POST',
              url: `blacklist/import`,
              data: formData,
              sendFile: true
            })
            this.loading = false;
            if (code === 200) {
              this.$message.success("Lista negra actualizada");
              this.formBlackList.resetFields();
            } else {
              this.$swal({
                icon: "warning",
                title: "¡Lo sentimos!",
                text: message,
              });
            }
          }
        },
      );
    },

    async searchEmail(debounce){
      if(this.buscar.trim() === '') {
        this.blackList = [];
        return
      }
      if(this.debounceSearchTimer !== null) {
        clearTimeout(this.debounceSearchTimer);
      }

      this.debounceSearchTimer = setTimeout(() => {
        this.sendRequest({
          method: 'GET',
          url: 'blacklist/search/' + this.buscar.toLowerCase(),
        }).then(({data}) => {
          this.blackList = data;
          this.debounceSearchTimer = null
        })
      }, debounce ? 1000 : 0)


    },

    handleFileUpload(){
      this.file = this.$refs.file.files[0];
    },

    recent() {
      this.sendRequest({
        method: 'GET',
        url: 'blacklist/recent',
      }).then(({data}) => {
        this.blackList = data;
      })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .titulo{
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #2c3e50;
  }
  .shadow {
    box-shadow: 2px 1px 5px -4px;
  }
  .shadowInputs {
    box-shadow: 1px 1px 5px -5px;
  }
  .nowrap{
    display: inline-flex;
  }
  .margin {
    margin: 0 2.5px;
  }
</style>




